import {IMultiOccurrence, IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import {IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IFormulaireItemSautDeLigneClass} from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import {IMenuClass} from '../../../../../core/services/menu/menu.service';
import {IMenuItemActionClass} from "../../../../../core/services/menu/menu-item-action.service";
import {IEcranDetailsResourcesEntite} from '../../../../../core/resources/ecran-details.resource';

interface IPageMc0091 {
    valeursEcran: any;
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
}
/* @ngInject */
export default function Mc0091Controller(Formulaire: IFormulaireClass,
                                         ecranDetails: IEcranDetailsResourcesEntite,
                                         Menu: IMenuClass,
                                         MenuItemAction: IMenuItemActionClass,
                                         FormulaireItem: IFormulaireItemClass,
                                         FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass) {
    const vm: IPageMc0091 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    vm.multiOccurrenceOptions = {
        actions: new Menu([

            new MenuItemAction(
                'LBL_BTN_DETRUIRE',
                'BOUDET',
                () => ({}),
                {
                    iconButton: false,
                    class: 'ex-button-action ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
                    successAction: () => {
                        vm.multiOccurrence.fetchDataList();
                    },
                    saveFirst: true,
                    messageConfirmation: 'BOUDET_CONFIRM'
                }
            )

        ]),
        fonctions: {
            importation: true
        },
        colonnesVisibles: [
            {nom: 'cnvnumlig', largeur: 100},
            {nom: 'cnvcha1', largeur: 120},
            {nom: 'cnvcha2', largeur: 100},
            {nom: 'cnvcha3', largeur: 300},
            {nom: 'cnvcha4', largeur: 200},
            {nom: 'cnvcha5', largeur: 120},
            {nom: 'cnvcha6', largeur: 120},
            {nom: 'cnvcha7', largeur: 100},
            {nom: 'cnvcha8', largeur: 120},
            {nom: 'cnvcha9', largeur: 120},
            {nom: 'cnvcha10', largeur: 100},
            {nom: 'cnvcha11', largeur: 100},
            {nom: 'cnvcha12', largeur: 100},
            {nom: 'cnvcha13', largeur: 120},
            {nom: 'cnvcha14', largeur: 120},
            {nom: 'cnvcha15', largeur: 120},
            {nom: 'cnvcha16', largeur: 120},
            {nom: 'cnvcha17', largeur: 120},
            {nom: 'cnvcha18', largeur: 100},
            {nom: 'cnvcha19', largeur: 140},
            {nom: 'cnvcha20', largeur: 120},
            {nom: 'cnvcha21', largeur: 100},
            {nom: 'cnvcha22', largeur: 100},
            {nom: 'cnvcha23', largeur: 120},
            {nom: 'cnvcha24', largeur: 120},
            {nom: 'cnvcha25', largeur: 100},
            {nom: 'cnvcha26', largeur: 100},

            {nom: 'cnvcha46', largeur: 300},
            {nom: 'cnvcha47', largeur: 120},
            {nom: 'cnvcha48', largeur: 120},
            {nom: 'cnvcha49', largeur: 120},
            {nom: 'cnvcha50', largeur: 160},
            {nom: 'cnvcha51', largeur: 160},
            {nom: 'cnvcha52', largeur: 140},
            {nom: 'cnvcha53', largeur: 140},
            {nom: 'cnvcha54', largeur: 140}
        ],
        formulaire: new Formulaire([
            new FormulaireItem('cnvnumlig', {largeur: 20}),
            new FormulaireItem('cnvcha1', {largeur: 20}),
            new FormulaireItem('cnvcha2', {largeur: 20}),
            new FormulaireItem('cnvcha3', {largeur: 20}),
            new FormulaireItem('cnvcha4', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha5', {largeur: 20}),
            new FormulaireItem('cnvcha6', {largeur: 20}),
            new FormulaireItem('cnvcha7', {largeur: 20}),
            new FormulaireItem('cnvcha8', {largeur: 20}),
            new FormulaireItem('cnvcha9', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha10', {largeur: 20}),
            new FormulaireItem('cnvcha11', {largeur: 20}),
            new FormulaireItem('cnvcha12', {largeur: 20}),
            new FormulaireItem('cnvcha13', {largeur: 20}),
            new FormulaireItem('cnvcha14', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha15', {largeur: 20}),
            new FormulaireItem('cnvcha16', {largeur: 20}),
            new FormulaireItem('cnvcha17', {largeur: 20}),
            new FormulaireItem('cnvcha18', {largeur: 20}),
            new FormulaireItem('cnvcha19', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha20', {largeur: 20}),
            new FormulaireItem('cnvcha21', {largeur: 20}),
            new FormulaireItem('cnvcha22', {largeur: 20}),
            new FormulaireItem('cnvcha23', {largeur: 20}),
            new FormulaireItem('cnvcha24', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha25', {largeur: 20}),
            new FormulaireItem('cnvcha26', {largeur: 20}),
            new FormulaireItem('cnvcha46', {largeur: 20}),
            new FormulaireItem('cnvcha47', {largeur: 20}),
            new FormulaireItem('cnvcha48', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha49', {largeur: 20}),
            new FormulaireItem('cnvcha50', {largeur: 20}),
            new FormulaireItem('cnvcha51', {largeur: 20}),
            new FormulaireItem('cnvcha52', {largeur: 20}),
            new FormulaireItem('cnvcha53', {largeur: 20}),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('cnvcha54', {largeur: 20})
        ])
    };
}
